import { TypographyV3 } from '@jouzen/ecom-components';
import { type RichTranslationValues, useTranslations } from 'next-intl';
import type { MessageKey } from 'types/LocaleMessageKey';

interface LegalParagraphProps {
  readonly tx: MessageKey;
  readonly className?: string;
  readonly values?: RichTranslationValues;
}

const LegalParagraph = ({
  tx: text,
  className = '',
  values,
}: LegalParagraphProps): JSX.Element => {
  const t = useTranslations();
  const copy = values ? t.rich(text, values) : t.rich(text);
  return (
    <TypographyV3 Element="p" className={className}>
      {copy}
    </TypographyV3>
  );
};

export default LegalParagraph;
